import Component from "vue-class-component";
import Vue from "vue";
import {
    EducationalInstitution,
    factory,
    QualificationRecordModel
} from "@/api-client";

@Component
export class AddQualificationRecordBase extends Vue {
    record!: QualificationRecordModel;
    selectedInstitution: EducationalInstitution | null = factory.create(EducationalInstitution);
    
    setSelectedInstitution(institution: EducationalInstitution){
        this.selectedInstitution = institution;
        this.record.educationalInstitutionId = institution.id;
    }
}
